
<div class="form-group" [formGroup]="form">
  <div *ngIf="field.IsGroupNameRendered" style="line-height:22px">
    <label class="form-control-label lb">
      <span [attr.style]="field.QuestionGroupNameStyle" *ngIf="formInfo.DisplayOrdinals">{{field.QuestionOrdinal}}&nbsp;</span><span [attr.style]="field.QuestionGroupNameStyle" [innerHTML]="field.QuestionGroupName"></span>
    </label>
  </div>
  <div class="row">
    <div class="question_text col-md-4">
      <label class="form-control-label lb" [attr.for]="field.QuestionText" [attr.style]="field.QuestionTextStyle">
        <span *ngIf="formInfo.DisplayOrdinals">{{field.QuestionOrdinal}}.{{field.QuestionGroupOrdinal == 0 ? '' : field.QuestionGroupOrdinal}}{{field.QuestionGroupOrdinal == 0 ? '' : '.&nbsp;'}}</span>
        {{field.QuestionText}}
        <strong class="text-danger" *ngIf="field.IsRequired">* &nbsp;</strong>
        <img id='f{{field.QuestionID}}' src='{{cdnEndPoint}}/triport/icons/redflag.jpg' width='15' height='15' *ngIf="field.IsFlagged" />
      </label>
      <br />
      <small *ngIf="field.QuestionRender != 'None'" [attr.style]="field.QuestionSubTextStyle">{{field.QuestionSubText}}</small>
    </div>
    <div class="col-md-8 question_answers">
      <ng-container [ngSwitch]="field.QuestionType">

        <ng-container *ngSwitchCase="'MergeField'">
          <medpt-date *ngIf="field.MergeFieldName == 'Date'" [field]="field" [form]="form"></medpt-date>
          <medpt-textbox *ngIf="field.MergeFieldName != 'Date' && !isCustomDropdown" [field]="field" [form]="form"></medpt-textbox>
          <medpt-dropdown *ngIf="isCustomDropdown" [field]="field" [form]="form"></medpt-dropdown>
        </ng-container>

        <ng-container *ngSwitchCase="'Date'">
          <medpt-date [field]="field" [form]="form"></medpt-date>
        </ng-container>

        <ng-container *ngSwitchCase="'Timezone'">
          <medpt-dropdown [field]="field" [form]="form"></medpt-dropdown>
        </ng-container>

        <ng-container *ngSwitchCase="'Time'">
          <medpt-time [field]="field" [form]="form"></medpt-time>
        </ng-container>

        <ng-container *ngSwitchCase="'ShortAnswer'">
          <medpt-textbox [field]="field" [form]="form"></medpt-textbox>
        </ng-container>

        <ng-container *ngSwitchCase="'ShortAnswerCal'">
          <medpt-textbox [field]="field" [form]="form"></medpt-textbox>
        </ng-container>

        <ng-container *ngSwitchCase="'ShortAnswerFormulaCal'">
          <medpt-textbox [field]="field" [form]="form"></medpt-textbox>
        </ng-container>

        <ng-container *ngSwitchCase="'LongAnswer'">
          <medpt-textbox [field]="field" [form]="form"></medpt-textbox>
        </ng-container>

        <ng-container *ngSwitchCase="'SelectAnswer'">
          <medpt-dropdown [field]="field" [form]="form"></medpt-dropdown>
        </ng-container>

        <ng-container *ngSwitchCase="'MultipleAnswer'">
          <medpt-checkbox [field]="field" [form]="form"></medpt-checkbox>
        </ng-container>

        <ng-container *ngSwitchCase="'MultipleChoice'">
          <medpt-radio [field]="field" [form]="form"></medpt-radio>
        </ng-container>

        <ng-container *ngSwitchCase="'Matrix'">
          <medpt-matrix [field]="field" [form]="form"></medpt-matrix>
        </ng-container>

        <!--<medpt-file *ngSwitchCase="'file'" [field]="field" [form]="form"></medpt-file>-->
        <!--<div class="text-danger small fadeInDown animated" *ngIf="(form.controls[field.uniquename].touched || submitted) && form.controls[field.uniquename].errors?.['required']">{{field.QuestionText}} is required</div>-->

      </ng-container>
    </div>
  </div>
</div>
